// extracted by mini-css-extract-plugin
export default {"valueContainer":"OperatorCommissionSelector_valueContainer__iE-Db","inputPercentage":"OperatorCommissionSelector_inputPercentage__0tEJH"};